import { useInvoiceInfo } from '../../app/Billing/Invoice/InvoiceInfo/InvoiceInfoProvider';
import useApi from '../../hook/useApi';
import cn from '../../utils/cn';
import { GetCurrencySymbol } from '../../utils/Currency';
import { GetFloatNumber } from '../../utils/NumberFormatter';
import { GetDate } from '../../utils/Show';
import { CrossIcon } from '../../utils/SVGIcon';
import { useTemplate } from '../template/TemplateProvider';

function Tr({ item, serial }) {
    const { setConfirm, setMessage, setTemplateLoading } = useTemplate();
    const { handleReload, invoiceInfo } = useInvoiceInfo();
    const { put } = useApi();

    const isUnpaid = invoiceInfo?.invoice?.amountPaid < 1;
    const isServiceItem = item?.productType === 'service';
    const handleRemove = (invoiceId, itemId, title) => {
        setConfirm({
            text: `Are you sure you want to remove the service item "${title}"?`,
            textAction: 'Yes, Remove',
            clickAction: () => {
                setTemplateLoading(true);
                put(`api/invoices/${invoiceId}/service-items/${itemId}/remove`)
                    .then(({ error, message }) => {
                        if (error) {
                            throw new Error(message);
                        }

                        setMessage({ type: 'success', text: message });
                        setConfirm(null);
                        handleReload();
                    })
                    .catch((ex) => {
                        setMessage({ type: 'error', text: ex?.message });
                    })
                    .finally(() => {
                        setTemplateLoading(false);
                    });
            }
        });
    };

    return (
        <tr
            className={cn(
                ` h-auto align-top group print:break-inside-avoid print:page-break-inside-avoid [&>td]:pt-5 [&>td>*]:text-xs2`,
                {
                    'placeholder-mode': item?.demo
                }
            )}
        >
            <td className=" text-invoice-primary">
                <span>{serial}</span>
            </td>
            <td className="">
                <div className="flex justify-start items-start gap-2 mb-1">
                    <div className="">
                        <span className="text-invoice-primary">{item?.productTitle || '--'}</span>
                        <br />
                        <span className="text-invoice-secondary mt-px">
                            {item?.packageName || '--'}
                        </span>
                        <p className="text-invoice-secondary mt-px">
                            <span>{item?.property || ``}</span>
                        </p>
                        {item?.subscriptionStart > 0 && item?.productType === 'service' ? (
                            <p className="text-invoice-secondary">
                                <span>
                                    {GetDate(item?.subscriptionStart)} {' - '}
                                    {GetDate(item?.subscriptionEnd)}
                                </span>
                            </p>
                        ) : null}
                        {item?.domain && <span className=""> &nbsp;#{item?.domain}</span>}
                    </div>
                </div>
            </td>
            <td className="text-invoice-primary text-center">
                <span>{item?.quantityString?.split('/').join('<br>')}</span>
            </td>
            <td className="text-center text-invoice-primary">
                <span>
                    {item?.priceUnitString?.toLowerCase() === 'free service' &&
                        GetCurrencySymbol(item?.currency)}
                    {item?.priceUnitString}
                </span>
            </td>

            <td className="text-invoice-primary text-center">
                <span>{item?.vatAmount || '--'}</span>
            </td>
            <td className="text-invoice-primary text-right">
                <div className="invoice-item-total relative">
                    <span>
                        {/* {GetCurrencySymbol(item?.currency)} */}
                        {GetFloatNumber(item?.totalPrice)}
                    </span>

                    {isUnpaid &&
                    isServiceItem &&
                    item?.subscriptionServiceId === 0 &&
                    invoiceInfo?.invoice?.authorizedBy <= 0 &&
                    invoiceInfo?.invoice?.status !== 'canceled' ? (
                        <button
                            type="button"
                            onClick={() =>
                                handleRemove(item?.invoiceId, item?.id, item?.productDescription)
                            }
                            className="absolute inline-flex items-center justify-center w-6 h-6 top-5 right-1 bg-red-200 hover:bg-error text-error hover:text-white  rounded-full transition-colors print:hidden"
                            aria-label="Loading..."
                        >
                            <CrossIcon />
                        </button>
                    ) : null}
                </div>
            </td>
        </tr>
    );
}

function InvoiceDataTable({ info }) {
    const items = info?.invoiceItems;

    return (
        <table className="w-full mb-5 table-fixed print:table-auto">
            <thead className="print:break-inside-avoid print:page-break-inside-avoid print:table-header-group">
                <tr className="*:text-xs2 *:font-bold *:text-invoice-primary">
                    <th className="w-[40px] text-left">Item</th>
                    <th className="text-left">Description</th>
                    <th className="w-[80px] text-center">Qty</th>
                    <th className="w-[100px] text-center">Price/Unit</th>
                    <th className="w-[80px] text-center">VAT/Tax</th>
                    <th className="w-[100px] text-right">Price ({info?.invoice?.currency})</th>
                </tr>
            </thead>
            <tbody className="print:table-row-group">
                {items?.map((item, i) => (
                    <Tr key={item.id} item={item} serial={i + 1} />
                ))}
            </tbody>
        </table>
    );
}

export default InvoiceDataTable;
